var React = require('react');

function AsanaCat (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","strokeWidth":"2","strokeMiterlimit":"10","d":"M34,31h-3V11.535 M31,26.874\n\tc0,0,0.711,0.126,1,0.126c2.762,0,5-2.238,5-5c0-1.125-0.48-2.091-0.998-2.997C32,12,28.417,7,22,7c-5.393,0-13,4-13,9\n\tc0,2.126,0.374,4.313,1.319,10.56L3,27l-1.526,4c0,0,9.712,0,10.712,0C13.842,31,15,30,15,28s0-9,0-9s2.5-4,7-4c2.083,0,5,3,5,3\n\tl-2.664,2.79L27,24.188"}));
}

AsanaCat.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"38px","height":"38px","viewBox":"0 0 38 38","enableBackground":"new 0 0 38 38","xmlSpace":"preserve"};

module.exports = AsanaCat;

AsanaCat.default = AsanaCat;
